module.exports = __webpack_public_path__ + "static/img/cinemaBottom4.f65beeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cinemaBottom4.png
// module id = UFpJ
// module chunks = 2